import { initState, } from '../core/state';
const isObservableStateable = (fn) => typeof fn === 'object' && 'onStateChange' in fn;
/**
 * Decorator function for adding state helper methods to a class
 *
 * @param targetClass Class object to be decorated
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const stateable = (moduleName) => function stateableWithContext(targetClass) {
    const { prototype } = targetClass;
    // eslint-disable-next-line func-names
    prototype.initState = function (initialState, isLoggingEnabled = false) {
        const initParams = {
            initialState,
            moduleName,
            isLoggingEnabled,
        };
        if (isObservableStateable(this)) {
            initParams.stateChangeCallback = this.onStateChange.bind(this);
        }
        // Weird destructuring/assignment so the functions can be set as functions specific to the exact object
        // instanceStateObject
        const { getState, setState } = initState(initParams);
        this.getState = getState;
        this.setState = setState;
    };
    return targetClass;
};
